<template>
  <div>
    <div class="top-search">
      <el-select v-model="chooseName" filterable placeholder="请选择">
        <el-option
          v-for="item in allUser"
          :key="item.id"
          :label="item.userName"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <div class="all-btn">
        <el-button type="primary" @click="searchItem('search')">查询</el-button>
        <el-button type="primary" plain @click="searchItem('reset')"
          >重置</el-button
        >
        <el-button type="primary" @click="addDate()">新增</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loadingData"
      >
        <el-table-column
          prop="compensatoryLeavePerson"
          label="调休人"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="attendancedate" label="加班日期" width="180">
        </el-table-column>
        <!--标题、备注不一样 -->
        <el-table-column prop="hourleaveorg" label="加班时长/h">
        </el-table-column>
        <el-table-column prop="hourleave" label="剩余可用时长/h">
        </el-table-column>
        <el-table-column prop="state" label="是否已过期">
          <template slot-scope="scope">
            <span>{{ scope.row.state == 1 ? "正常" : "已过期" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdBy" label="创建人"> </el-table-column>
        <el-table-column prop="createDate" label="创建时间"> </el-table-column>
        <el-table-column prop="state" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="handleClick(scope.row, 'edit')"
              type="text"
              size="small"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="handleClick(scope.row, 'del')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="allCount"
        @current-change="handleCurrentChange"
        class="page-item"
        :current-page="searchParams.page"
      >
      </el-pagination>
    </div>
    <!-- 新增弹窗 start -->
    <el-dialog
      :title="type == 'add' ? '新增调休' : '更改调休'"
      :visible.sync="showAdd"
      width="50%"
      :before-close="closeDiv"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="调休人" prop="uId">
          <el-select
            v-model="ruleForm.uId"
            filterable
            placeholder="请选择调休人"
          >
            <el-option
              v-for="item in allUser"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="date" label="加班时间">
          <el-date-picker
            v-model="ruleForm.date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="加班时长" prop="duration">
          <el-radio-group v-model="ruleForm.duration">
            <el-radio :label="4">4h</el-radio>
            <el-radio :label="8">8h</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否已过期" prop="state">
          <el-radio-group v-model="ruleForm.state">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">已过期</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button
          type="primary"
          @click="onSubmit('ruleForm')"
          :loading="submitLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增弹窗 ennd -->
  </div>
</template>
<script>
import { LeaveInfo,ScheduleAll } from "../../API/api";
export default {
  data() {
    return {
      type: "add",
      submitLoading: false,
      chooseName: "",
      showAdd: false,
      searchParams: {
        limit: 10,
        page: 1,
        uId: 0,
      },
      loadingData: true,
      allUser: [],
      tableData: [],
      allCount: 0,
      ruleForm: {
        NId: JSON.parse(localStorage.getItem("userInfo")).id,
        date: null,
        duration: 4,
        uId: null,
        state: 1,
      },
      rules: {
        uId: [{ required: true, message: "请选择调休人", trigger: "change" }],
        date: [
          {
            required: true,
            message: "请选择加班日期",
            trigger: "change",
          },
        ],
        duration: [
          { required: true, message: "请选择加班时长", trigger: "change" },
        ],
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  mounted() {
    this.getData();
    this.getAllUser();
  },
  methods: {
    closeDiv() {
      this.showAdd = false;
      (this.ruleForm = {
        NId: JSON.parse(localStorage.getItem("userInfo")).id,
        date: null,
        duration: 4,
        uId: null,
        state: 1,
      }),
        (this.ruleForm = {
          NId: JSON.parse(localStorage.getItem("userInfo")).id,
          date: null,
          duration: 4,
          uId: null,
          state: 1,
        });
    },
    //新增按钮
    addDate() {
      this.showAdd = true;
      this.type = "add";
    },
    //删除或者编辑
    handleClick(item, type) {
      console.log(type, "type----");
      if (type == "del") {
        let params = {
          id: item.id,
        };
        this.$http
          .post(LeaveInfo.delItem, this.qs.stringify(params))
          .then((res) => {
            const { retCode, retMsg } = res.data;
            if (retCode == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getData();
            } else {
              this.$message({
                message: `${retMsg}`,
                type: "error",
              });
            }
          });
      } else {
        this.showAdd = true;
        this.type = "update";
        const { userid, hourleaveorg, attendancedate, state } = item;
        this.ruleForm = {
          date: attendancedate,
          duration: hourleaveorg,
          uId: userid,
          NId: JSON.parse(localStorage.getItem("userInfo")).id,
          state,
        };
      }
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.tableData = [];
      this.getData();
    },
    //新增-重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.showAdd = false;
      this.ruleForm = {
        NId: JSON.parse(localStorage.getItem("userInfo")).id,
        date: null,
        duration: 4,
        uId: null,
        state: 1,
      };
    },

    //新增、编辑调休
    onSubmit(formName) {
      this.$refs[formName].validate((valid, obj) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .post(LeaveInfo.AddOrmodify, this.qs.stringify(this.ruleForm))
            .then((res) => {
              console.log(res, "res-----");
              this.submitLoading = false;
              const { retCode, retMsg } = res.data;
              if (retCode == 200) {
                this.$message({
                  message: `${this.type == "add" ? "新增" : "修改"}成功`,
                  type: "success",
                });
                this.showAdd = false;
                this.$refs[formName].resetFields();
                this.searchParams = {
                  limit: 10,
                  page: 1,
                  uId: 0,
                };
                this.ruleForm = {
                  NId: JSON.parse(localStorage.getItem("userInfo")).id,
                  date: null,
                  duration: 4,
                  uId: null,
                  state: 1,
                };
                this.getData();
              } else {
                this.$message({
                  message: `${retMsg}`,
                  type: "error",
                });
              }
            });
        } else {
          console.log("error submit!!", obj);
          for (const prop in obj) {
            if (!this.ruleForm[prop]) {
              this.$message({
                message: obj[prop][0].message,
                type: "warning",
              });
              break;
            }
          }

          return false;
        }
      });
    },
    //搜索-查询-重置
    searchItem(type) {
      console.log(this.chooseName, "chooseName");
      if (type == "reset") {
        this.searchParams = {
          limit: 10,
          page: 1,
          uId: 0,
        };
        this.chooseName = "";
      } else {
        this.searchParams.uId = this.chooseName || 0;
      }
      this.tableData = [];
      this.getData();
    },
    //获取表格信息
    getData() {
      //application/json;charset=UTF-8
      this.loadingData = true;
      this.$http
        .post(LeaveInfo.getList, this.qs.stringify(this.searchParams))
        .then((res) => {
          const { data, count } = res.data.retData;
          this.tableData = data;
          this.allCount = count;
          this.loadingData = false;
          console.log(this.tableData, "tableData");
        });
    },
    //获取所有人信息
    getAllUser() {
      this.$http.post(ScheduleAll.allUsers).then((res) => {
        console.log(res, "res-----");
        this.allUser = res.data.retData.data;
        console.log(this.allUser,'this.allUser')
      });
    },
  },
};
</script>
<style lang="less" scoped>
.top-search {
  width: 100%;
  display: flex;
  //   justify-content: space-between;
  margin-bottom: 24px;
  .el-select {
    width: 400px;
  }
  .all-btn {
    margin-left: 24px;
  }
}
.page-item {
  margin-top: 24px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>